import { type RefData } from '../../../types/apiModels'
import { EXCLUSION_AREA_TYPE_IDS } from '../../../utils/constants'

export type ExclusionAreaTypeId = string | number

export type ExclusionAreaType = Pick<RefData, 'id'> & Partial<RefData>

export type ExclusionAreaProperties = {
  id?: string
  name?: string
  otherName?: string
  exclusionAreaTypeId?: ExclusionAreaTypeId | null
  featureGroup?: string
  hasGrazingManagement?: boolean
  [key: string]: unknown
}

export type ExclusionAreaFeature = {
  type: 'Feature'
  properties: ExclusionAreaProperties
  geometry: GeoJSON.Geometry
}

export const OTHER_EXCLUSION_AREA_TYPE_ID = Number(EXCLUSION_AREA_TYPE_IDS.OTHER)

// KML ExtendedData delivers every property as text, so stored ids reach the row as "2".
export const toTypeId = (value: ExclusionAreaTypeId | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') return null
  const typeId = Number(value)
  return Number.isNaN(typeId) ? null : typeId
}

export const isCatalogType = (
  typeId: number | null,
  exclusionAreaTypes?: ExclusionAreaType[],
): typeId is number =>
  typeId !== null && (exclusionAreaTypes || []).some(type => toTypeId(type?.id) === typeId)

export const resolveSelectedExclusionAreaTypeId = (
  selectedValue: ExclusionAreaTypeId,
  exclusionAreaTypes?: ExclusionAreaType[],
): number => {
  const typeId = toTypeId(selectedValue)
  return isCatalogType(typeId, exclusionAreaTypes) ? typeId : OTHER_EXCLUSION_AREA_TYPE_ID
}

/**
 * `typeId` is what the feature keeps (and saves); `selectedTypeId` is empty unless the catalog
 * offers that option, because the select cannot show a value it has no MenuItem for.
 */
export const resolveHydratedExclusionAreaType = (
  properties: ExclusionAreaProperties | undefined,
  exclusionAreaTypes?: ExclusionAreaType[],
): { typeId: number | null; selectedTypeId: number | '' } => {
  const typeId = toTypeId(properties?.exclusionAreaTypeId)
  return {
    typeId,
    selectedTypeId: isCatalogType(typeId, exclusionAreaTypes) ? typeId : '',
  }
}
